import { CodeNameEntity } from "../common/code-name-entity";
import { Offer } from "./offer";

export class EmailManager {
    id: number;
    code: string;
    name: string;
    state: any;
    emailType: CodeNameEntity;
    offer: Offer;

    constructor (id: number, code: string, name: string, emailType: CodeNameEntity) {
        this.id = id;
        this.code = code;
        this.name = name;
        this.emailType = emailType;
        this.offer = this.offer;
    }
}
